import React, { useLayoutEffect } from "react";

function walk(node) {
  if (node == null || node === false) return;
  if (Array.isArray(node)) {
    node.forEach((n) => walk(n));
    return;
  }
  if (!React.isValidElement(node)) return;

  const { type, props } = node;

  if (type === React.Fragment) {
    React.Children.forEach(props.children, (c) => walk(c));
    return;
  }

  if (type === "title") {
    const t = props.children;
    document.title =
      typeof t === "string" || typeof t === "number"
        ? String(t)
        : Array.isArray(t)
          ? t.map(String).join("")
          : "";
    return;
  }

  if (type === "meta") {
    const { name, property, content } = props;
    const attr = property != null ? "property" : "name";
    const key = property != null ? property : name;
    if (!key) return;
    let el = document.head.querySelector(`meta[${attr}="${CSS.escape(String(key))}"]`);
    if (!el) {
      el = document.createElement("meta");
      el.setAttribute(attr, String(key));
      document.head.appendChild(el);
    }
    if (content != null) el.setAttribute("content", String(content));
  }
}

/**
 * Applies Next.js-style &lt;Head&gt; fragment content to `document.head` (CRA has no next/head).
 */
export default function SyncNextStyleHead({ children }) {
  useLayoutEffect(() => {
    const prevTitle = document.title;
    walk(children);
    return () => {
      document.title = prevTitle;
    };
  }, [children]);

  return null;
}
